<div class="selectDropdown" [ngStyle]="{ width: isMobile ? 'unset' : dropdownWidth }">
  <pp-hide-dropdown (ppHideDropdown)="hideDropdown()"></pp-hide-dropdown>

  <ul class="dropdownWrapper dropdownWrapper--grouped">
    @for (item of items; track item) {
      @let hasMessage = !!item?.value?.message;
      <li
        class="select__optionGroup"
        [class.select__optionValue--active]="hasMessage"
        [class.select__optionValue]="hasMessage"
        (click)="item.value ? selectItem(item.value) : null"
      >
        <span
          class="select__optionValue--title"
          [class.select__optionValue--active--span]="hasMessage"
          >{{ item.label }}

          @if (hasMessage) {
            <pp-select-dropdown-selected-mark [ppText]="item.value.message | ppTranslate" />
          }
        </span>

        <ul class="select__optionValue__sublist">
          @for (option of item.options; track option) {
            @if (option.enabled) {
              <li
                class="select__optionValue select__optionValue--enabled"
                (click)="selectItem(option)"
                [class.dropdownItem--selected]="selectedItem?.id === option.id"
              >
                <span>{{ option.name }} </span>
                @if (option.message) {
                  <pp-select-dropdown-selected-mark
                    [ppText]="option.message | ppTranslate"
                  ></pp-select-dropdown-selected-mark>
                }
              </li>
            }
            @if (!option.enabled) {
              <li class="select__optionValue select__optionValue--disabled">
                <span
                  ppTooltip
                  [ppTitle]="option.disabledMessage | ppTranslate"
                  [ppOptions]="{ placement: 'right' }"
                >
                  {{ option.name }}
                </span>
                @if (option.message) {
                  <pp-select-dropdown-selected-mark
                    [ppText]="option.message | ppTranslate"
                  ></pp-select-dropdown-selected-mark>
                }
              </li>
            }
          }
        </ul>
      </li>
    }
  </ul>
</div>
